import { Panel } from "../../../primitives/surfaces/Panel";
import { Body } from "../../../primitives/data-display/Body";

interface ClaimDisplayProps {
  claim: string;
}

/** The user's claim, displayed consistently across extraction, analysis, and result pages. */
export function ClaimDisplay({ claim }: ClaimDisplayProps) {
  return (
    <Panel tone="accent">
      <Body fontStyle="italic">&ldquo;{claim}&rdquo;</Body>
    </Panel>
  );
}
